<template>
  <router-view></router-view>
</template>

<script>
export default {
  methods: {
    initializeLayout() {
      if (!this.$rtl.isRTL) {
        // Just make sure rtl css is off when we are not on rtl
        this.$rtl.disableRTL();
      }
    }
  },
  created() {
    this.$auth.init();
    if(!this.$auth.user){
      this.$router.push(`/login`)
    }
  },
  mounted() {
    this.initializeLayout();
  }
};
</script>
